<script>
export default {
  name: "InnerCheckbox",
  functional: true,
  render: function (h, {props, parent, children, listeners, ...args}) {
    let {name, enumValues, value,showLabel} = props;
    const change = listeners.change;
    return (<div class={'sliderInput'}>
      {name && showLabel && <span class="scence_ctr_span_title">{ name }</span>}
          <el-checkbox-group onChange={change} value={value}>
          {enumValues.map(el => <el-checkbox key={el.Value} label={el.Value}>{el.Name}</el-checkbox>)}
        </el-checkbox-group>
      
    </div>

    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
</style>
